
<app-partner-user-list [partnership]="relationship" *ngIf="relationship"></app-partner-user-list>
<br>
<div class="custom-button-link-secoundary">
    <a href="{{managePartnerUri}}" >Back</a>    
</div>